export interface ToolsInfo {
  name: string;
  creationDate: string;
  title: string;
  description: string;
  isActive: boolean;
}

export interface DbTemplate {
}

export interface IcureGroup {
}

export enum ConnectionType {
  "OAUTH" = "OAuth",
  "BASIC" = "Basic"
}
